import { Newsletter } from '@components/organisms/Newsletter/Newsletter';

export default function ContentElementNewsletter() {
  return <Newsletter />;
}
